import React from 'react';
import { Link as DomLink } from 'react-router-dom';

import AttendanceActions, { useRegisteredStage } from 'Components/Partials/AttendanceActions';

/**
 * Reusable Join Us footer used across several pages.
 * Accepts optional props to override targets/text/classes but defaults match existing markup.
 *
 * A delegate who already has a place is not asked to register again — they get the status
 * they hold and, where there is something to give up, the matching cancel action.
 */
export default function JoinUs({
    registerTo = '/registration',
    infoTo = '/information',
    registerClass = 'bg-white text-app-blue px-4 py-2 rounded',
    infoClass = 'border border-white text-white px-4 py-2 rounded',
    containerClass = 'bg-app-blue text-white py-10 md:py-20',
    innerClass = 'max-w-6xl mx-auto px-6 text-center'
}) {
    const stage = useRegisteredStage();

    const messages = {
        'confirm-attending': 'Your in-person place at Symposium 2026 is reserved',
        'confirm-waitlist': "You're on the in-person waitlist for Symposium 2026",
        'confirm-not-attending': 'Your virtual place at Symposium 2026 is reserved',
    };

    return (
        <div className={containerClass}>
            <div className={innerClass}>
                <div className="font-bold mb-2">Join Us</div>
                <div className="mb-4 underline">
                    {messages[stage] ?? 'Reserve your place at Symposium 2026 today'}
                </div>
                <div className="flex justify-center gap-4">
                    <AttendanceActions className={registerClass} registerTo={registerTo} />

                    <DomLink to={infoTo} className={infoClass}>Learn More</DomLink>
                </div>
            </div>
        </div>
    );
}
